import { render, staticRenderFns } from "./SiswaMonitoring.vue?vue&type=template&id=91c40ba2&scoped=true"
import script from "./SiswaMonitoring.vue?vue&type=script&lang=js"
export * from "./SiswaMonitoring.vue?vue&type=script&lang=js"
import style0 from "./SiswaMonitoring.vue?vue&type=style&index=0&id=91c40ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c40ba2",
  null
  
)

export default component.exports